import React from 'react';
import { wire } from 'react-hot-wire';
import BattlesService from 'services/battles/BattlesService';
import BrowserHistoryService from 'services/application/BrowserHistoryService';
import useGetBattleGroupList from 'components/battles/hook/api/useGetBattleGroupList';
import Loader from 'components/commons/_/loader/Loader';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import moment from 'moment';
import AvailableBattleGroup from 'models/battles/AvailableBattleGroup';

export type SelectGroupProps = {
	onSelect: (group: AvailableBattleGroup) => void;
};
export type SelectGroupWiredProps = SelectGroupProps & {
	'services.battlesService': BattlesService;
	'services.browserHistoryService': BrowserHistoryService;
};

export const SelectGroup = ({
	onSelect,
	'services.browserHistoryService': browserHistoryService,
	...props
}: SelectGroupWiredProps) => {
	const battleGroupListQuery = useGetBattleGroupList(props);
	const tomorrow = moment(new Date()).add(1, 'days');

	return (
		<div className="battlesSelectGroup">
			<div className="battlesSelectGroup__list">
				{battleGroupListQuery.isLoading ? (
					<div className="d-flex justify--center">
						<Loader fixed={false} />
					</div>
				) : (
					<>
						{battleGroupListQuery.data?.count === 0 ? (
							<div className="empty">
								<FormattedMessage id="battles.start-new-game.no-battle-groups" />
							</div>
						) : (
							battleGroupListQuery.data?.items.map(item => (
								<div
									className={classNames('battlesSelectGroup__list-element', {
										'battlesSelectGroup__list-element--disabled': item.locked,
									})}
									onClick={event => {
										event.stopPropagation();

										if (!item.locked) {
											onSelect(item);
										}
									}}
								>
									<div>{item.name}</div>
									{item.locked && item.nextBattleStartsAt && (
										<div className="battlesSelectGroup__list-element__disabled-info">
											<FormattedHTMLMessage
												id={
													item.nextBattleStartsAt.isSame(tomorrow, 'day')
														? 'battles.start-new-game.locked.tomorrow'
														: 'battles.start-new-game.locked.later'
												}
												values={{
													date: item.nextBattleStartsAt.format('DD.MM.YYYY'),
													time: item.nextBattleStartsAt.format('HH:mm'),
												}}
											/>
										</div>
									)}
								</div>
							))
						)}
					</>
				)}
			</div>
		</div>
	);
};

export default wire<SelectGroupWiredProps, SelectGroupProps>(
	['services.battlesService', 'services.browserHistoryService'],
	SelectGroup
);
